/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable eqeqeq */
/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable import/no-cycle */
// Libraries
import React, { MouseEvent, useCallback, useEffect, useMemo, useState } from 'react';

import { Button, Link, Select, SelectItem, styled, Subheading } from '@meterup/atto';
import {
  put,
  Quote,
  QuoteRequest,
  QuoteRequestOnboarding,
  QuoteRequestUpdateRequest,
  useApiResource,
} from '@meterup/connect-api';
import { QuoteRequest_Status } from '@meterup/connect-api/src/connectProtos';
import cx from 'classnames';
import { useNavigate, useParams } from 'react-router-dom';

// Components
import BaseLayout from '../../components/Layout/BaseLayout';
import ManualQuotesList from '../../components/Quotes/ManualQuotesList/ManualQuotesList';
import QuotesList from '../../components/Quotes/QuotesList/QuotesList';
import InstantQuotesResultsEmpty from '../../components/Shared/InstantQuotesResultsEmpty/InstantQuotesResultsEmpty';
import ProvidersProgress from '../../components/Shared/ProvidersProgress/ProvidersProgress';
import QuotesResultsEmpty from '../../components/Shared/QuotesResultsEmpty/QuotesResultsEmpty';
import QuotesResultsFilters from '../../components/Shared/QuotesResultsFilters/QuotesResultsFilters';
import useConnectionTypeFilter from '../../hooks/useConnectionTypeFilter';
import useContractLengthMonthsFilter from '../../hooks/useContractLengthMonthsFilter';
import useDownloadMbpsFilter from '../../hooks/useDownloadMbpsFilter';
import useMonthlyFeeFilter from '../../hooks/useMonthlyFeeFilter';
import useProvidersFilter from '../../hooks/useProvidersFilter';
// Hooks
import useQuotes from '../../hooks/useQuotes';
import { route } from '../../routes';
import { formatBandwidth } from '../../utils/formatBandwidth';

enum SortStrategy {
  Price = 'price',
  Bandwidth = 'bandwidth',
}

const SORT_OPTIONS = [
  { label: 'Sort by: price', value: SortStrategy.Price },
  { label: 'Sort by: bandwidth', value: SortStrategy.Bandwidth },
];

const StickyButtonContainer = styled('div', {
  position: 'sticky',
  bottom: 0,
  right: 10,
  left: 0,
  backgroundColor: 'white',
  borderTop: '1px solid #e5e7eb',
  zIndex: 999,
  padding: '1rem',
  paddingRight: '$40',

  display: 'flex',
  justifyContent: 'flex-end',

  '@media (max-width: 767px)': {
    left: 0,
    right: 0,
    justifyContent: 'center',
    padding: '1rem',
    '& > button': {
      width: '100%',
    },
  },

  '@media (min-width: 768px)': {
    '& > button': {
      width: 'auto',
    },
  },
});

export default function QuoteRequestsResults() {
  // Router
  const navigate = useNavigate();

  // QuoteRequest id
  const { sid } = useParams<{ sid: string }>();

  // Get quoteRequest
  const [loading, quoteRequest, reloadQuoteRequest] = useApiResource<QuoteRequest>(
    `quote-requests/${sid}`,
    false,
    true,
  );

  // Selected quotes SIDs
  const selectedQuoteSids = useMemo(
    () => (quoteRequest ? quoteRequest.selectedQuotes : []),
    [quoteRequest],
  );

  const [loadingQuoteRequestOnboarding, quoteRequestOnboarding] =
    useApiResource<QuoteRequestOnboarding>(`quote-requests/${sid}/onboarding`, false, true);

  // Quotes
  const {
    loadingQuotes,
    reloadQuotes,
    enabledQuotes,
    proposedQuotes,
    generatedQuotes,
    selectedQuotes,
    unselectedQuotes,
    recommendedQuotes,
    // @ts-ignore
  } = useQuotes(sid, selectedQuoteSids);

  // States - which quote is being updated
  const [quoteLoadingSid, setQuoteLoadingSid] = useState('');

  // States - Provider search progress bar
  const [progressPercentage, setProgressPercentage] = useState(10);

  // States - Part of the UI is blurred until we have quotes
  const [readyForReview, setReadyForReview] = useState(false);

  const [showMobileFilters, setShowMobileFilters] = useState(false);

  // States - Whether user is sorting by price or bandwidth
  const [sortStrategy, setSortStrategy] = useState(SortStrategy.Price);

  // We only show filters in the left sidebar if there's more than one quote
  const [showFilters, setShowFilters] = useState<boolean>(generatedQuotes.length > 1);

  useEffect(() => {
    setShowFilters(generatedQuotes.length > 1);
  }, [enabledQuotes]);

  // Monthly fee filter
  const {
    minMonthlyFee,
    maxMonthlyFee,
    currentMonthlyFee,
    onMonthlyPriceChange,
    resetMonthlyPriceFilter,
  } = useMonthlyFeeFilter(generatedQuotes);

  // DownloadMbps filter
  const {
    quotesByDownloadMbps,
    allDownloadMbps,
    currentDownloadMbps,
    onDownloadMbpsChange,
    resetDownloadMbpsFilter,
  } = useDownloadMbpsFilter(generatedQuotes, quoteRequest);

  // Contract length filter
  const {
    quotesByContractLengthMonths,
    allContractLengthMonths,
    currentContractLengthMonths,
    onContractLengthMonthsChange,
    resetContractLengthMonthsFilter,
  } = useContractLengthMonthsFilter(generatedQuotes);

  const {
    allConnectionTypes,
    currentConnectionTypes,
    onCurrentConnectionTypesChange,
    quotesByConnectionType,
    resetCurrentConnectionTypes,
  } = useConnectionTypeFilter(generatedQuotes);

  const {
    quotesByProvider,
    allProviders,
    currentProviders,
    onProvidersChange,
    resetProvidersFilter,
  } = useProvidersFilter(generatedQuotes);

  const resetFilters = (event: MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    resetMonthlyPriceFilter();
    resetDownloadMbpsFilter();
    resetContractLengthMonthsFilter();
    resetProvidersFilter();
    resetCurrentConnectionTypes();
  };

  // quotes filtered by above filters
  const filteredQuotes = useMemo(
    () =>
      unselectedQuotes
        .filter((quote: Quote) => quote.monthlyFeeCents / 100 <= currentMonthlyFee)
        .filter((quote: Quote) => currentContractLengthMonths.includes(quote.contractLengthMonths))
        .filter((quote: Quote) => currentDownloadMbps.includes(formatBandwidth(quote.downloadKbps)))
        .filter((quote: Quote) =>
          currentProviders.includes(quote.provider ? quote.provider.name : ''),
        )
        .filter((quote: Quote) =>
          currentConnectionTypes.includes(quote.connectionType?.name || 'unknown'),
        )
        .sort((a, b) => (a.monthlyFeeCents < b.monthlyFeeCents ? -1 : 1)),
    [
      unselectedQuotes,
      currentMonthlyFee,
      currentContractLengthMonths,
      currentDownloadMbps,
      currentProviders,
      currentConnectionTypes,
    ],
  );

  // User select an automated quote
  const onSelectQuote = useCallback(
    (quoteSid: string) => {
      // Set loading state for the quote
      setQuoteLoadingSid(quoteSid);

      const data = {
        selectedQuotes: [...selectedQuoteSids, quoteSid],
        selectedQuotesChanged: true,
      };

      // Request
      put<QuoteRequestUpdateRequest, QuoteRequest>(`quote-requests/${sid}`, data).then(
        (response) => {
          reloadQuoteRequest &&
            reloadQuoteRequest().then((response) => {
              setQuoteLoadingSid('');
              reloadQuotes && reloadQuotes();
            });
        },
      );
    },
    [selectedQuoteSids],
  );

  const onDeselectQuote = useCallback(
    (quoteSid: string) => {
      setQuoteLoadingSid(quoteSid);

      // Data
      const data = {
        selectedQuotes: selectedQuoteSids.filter((sid) => sid !== quoteSid),
        selectedQuotesChanged: true,
      };

      // Request
      put<QuoteRequestUpdateRequest, QuoteRequest>(`quote-requests/${sid}`, data).then(
        (response) => {
          reloadQuoteRequest &&
            reloadQuoteRequest().then((response) => {
              setQuoteLoadingSid('');
              reloadQuotes && reloadQuotes();
            });
        },
      );
    },
    [selectedQuoteSids],
  );

  const onPinQuote = useCallback((quoteSid: string) => {
    // setQuoteLoadingSid(quoteSid);
    const data = {
      recommended: true,
      recommendedChanged: true,
    };

    put(`quote-requests/${sid}/quotes/${quoteSid}`, data).then((response) => {
      reloadQuotes && reloadQuotes();
    });
  }, []);

  const onUnpinQuote = useCallback((quoteSid: string) => {
    // setQuoteLoadingSid(quoteSid);
    const data = {
      recommended: false,
      recommendedChanged: true,
    };

    put(`quote-requests/${sid}/quotes/${quoteSid}`, data).then((response) => {
      reloadQuotes && reloadQuotes();
    });
  }, []);

  // Request a manual quote
  const onRequestManualQuote = useCallback(
    (quoteSid: string) => {
      setQuoteLoadingSid(quoteSid);
      put(`quote-requests/${sid}/quotes/${quoteSid}`, { status: 'requested' }).then((response) => {
        reloadQuotes &&
          reloadQuotes().then((response) => {
            setQuoteLoadingSid('');
          });
      });
    },
    [selectedQuoteSids],
  );

  // Click next
  const onConfirmClick = useCallback(() => {
    if (sid) {
      navigate(route('confirm', { sid }));
    }
  }, [sid]);

  // Classes
  const sectionClasses = cx('transition-all duration-150', {
    'filter blur-sm': !readyForReview,
    'filter blur-0': !readyForReview,
  });

  // Markup
  const address = quoteRequest?.location?.address?.address1
    ? quoteRequest?.location?.address?.address1
    : '';

  // On render/QuoteRequest loaded
  useEffect(() => {
    let timer: ReturnType<typeof setTimeout>;

    if (!loadingQuotes && quoteRequest && quoteRequest.status !== QuoteRequest_Status.created) {
      setReadyForReview(true);
      // The API can take up to 2 minutes to return automated quotes
      // this "fake" progressing every 1.3 seconds
    } else {
      timer = setTimeout(() => {
        setProgressPercentage(progressPercentage + Math.random() * 2);
        reloadQuoteRequest && reloadQuoteRequest();
        reloadQuotes && reloadQuotes();
      }, 1300);
    }

    return () => {
      clearTimeout(timer);
    };
  }, [loading, loadingQuotes, quoteRequest, progressPercentage]);

  if (loading) {
    return null;
  }

  const renderMainContent = () => {
    let emptyView;
    if (enabledQuotes.length == 0) {
      emptyView = <QuotesResultsEmpty address={address} />;
    } else if (generatedQuotes.length == 0) {
      // @ts-ignore
      emptyView = <InstantQuotesResultsEmpty address={address} />;
    }

    const totalQuotes = generatedQuotes.length;
    const visibleQuotes = selectedQuotes.length + filteredQuotes.length;

    return (
      <div className="md:mt-0">
        {emptyView}
        {generatedQuotes.length > 0 && (
          <>
            <div className="mb-0 mt-2 px-4 flex justify-between items-center border-b border-gray-100 ">
              {visibleQuotes == totalQuotes && <Subheading>{visibleQuotes} Quotes</Subheading>}
              {visibleQuotes != totalQuotes && (
                <Subheading>
                  {visibleQuotes} out of{' '}
                  <Link href="#" onClick={resetFilters}>
                    {totalQuotes} quotes
                  </Link>
                </Subheading>
              )}
              <div className="inline-block mb-2">
                <Select
                  value={sortStrategy}
                  onValueChange={(v) => setSortStrategy(v as SortStrategy)}
                >
                  {SORT_OPTIONS.map((option) => (
                    <SelectItem key={option.value}>{option.label}</SelectItem>
                  ))}
                </Select>
              </div>
            </div>
            <div>
              <div className={filterButtonWrapperClass}>
                <div className="py-4">
                  <Button
                    onClick={() => setShowMobileFilters(true)}
                    arrangement="leading-icon"
                    icon="filter"
                    width="100%"
                    size="large"
                    variant="secondary"
                  >
                    Filters
                  </Button>
                </div>
              </div>
            </div>
            <div className="mt-2">
              <QuotesList
                quotes={filteredQuotes}
                // @ts-ignore
                selectedQuotes={selectedQuotes}
                recommendedQuotes={recommendedQuotes}
                selectedQuoteSids={selectedQuoteSids}
                shouldGroupByBandwidth={sortStrategy === SortStrategy.Bandwidth}
                onSelectQuote={onSelectQuote}
                onDeselectQuote={onDeselectQuote}
                quoteLoadingSid={quoteLoadingSid}
              />
            </div>
          </>
        )}
        {proposedQuotes.length > 0 && (
          <div className="mt-8 mb-12">
            <ManualQuotesList
              quotes={proposedQuotes}
              onRequestManualQuote={onRequestManualQuote}
              quoteLoadingSid={quoteLoadingSid}
            />
          </div>
        )}
      </div>
    );
  };

  const filterWrapperClass = cx(
    sectionClasses,
    'w-full pt-0 pb-12 px-4 mt-0',
    'md:inline-block md:max-w-xs md:col-span-3 md border-r border-gray-100',
    'md:h-screen md:overflow-y-auto md:sticky md:top-0',
    'md:pt-0',
    {
      hidden: !showMobileFilters,
      'absolute inset-0 bg-white z-50 top-16 bottom-18 overflow-auto overflow-x-hidden':
        showMobileFilters,
    },
  );

  const contentWrapperClass = cx(
    'w-full pt-0 pb-0',
    'md:border-r md: pt-0 border-gray-100 px-0 lg:px-6',
    {
      hidden: showMobileFilters,
    },
  );

  const filterButtonWrapperClass = cx('mt-12 md:hidden w-full px-4', {
    hidden: showMobileFilters,
  });

  const filteredButtonWrapperClass = cx(
    'bg-white w-full fixed z-200 left-0 bottom-0',
    'border-t border-gray-100 p-4 py-7 pr-0',
    'md:hidden',
    {
      hidden: !showMobileFilters,
    },
  );

  // TODO: Move filters to context
  return (
    <BaseLayout align="top" layoutMargin={false}>
      <div className="w-full flex flex-row">
        <div className={filterWrapperClass}>
          <QuotesResultsFilters
            quoteRequest={quoteRequest}
            showFilters={showFilters}
            minMonthlyFee={minMonthlyFee}
            maxMonthlyFee={maxMonthlyFee}
            currentMonthlyFee={currentMonthlyFee}
            onMonthlyPriceChange={onMonthlyPriceChange}
            quotesByDownloadMbps={quotesByDownloadMbps}
            allDownloadMbps={allDownloadMbps}
            currentDownloadMbps={currentDownloadMbps}
            onDownloadMbpsChange={onDownloadMbpsChange}
            quotesByContractLengthMonths={quotesByContractLengthMonths}
            allContractLengthMonths={allContractLengthMonths}
            currentContractLengthMonths={currentContractLengthMonths}
            onContractLengthMonthsChange={onContractLengthMonthsChange}
            quotesByProvider={quotesByProvider}
            allProviders={allProviders}
            currentProviders={currentProviders}
            onProvidersChange={onProvidersChange}
            allConnectionTypes={allConnectionTypes}
            currentConnectionTypes={currentConnectionTypes}
            onCurrentConnectionTypesChange={onCurrentConnectionTypesChange}
            quotesByConnectionType={quotesByConnectionType}
          />
          <div className={filteredButtonWrapperClass}>
            <Button onClick={() => setShowMobileFilters(false)} width="100%" size="large">
              Show {filteredQuotes.length} {filteredQuotes.length == 1 ? 'quote' : 'quotes'}
            </Button>
          </div>
        </div>

        <div className="flex-1 flex-col">
          <div className={contentWrapperClass}>
            {!readyForReview && <ProvidersProgress progress={progressPercentage} />}
            {readyForReview && renderMainContent()}
          </div>
          {readyForReview && selectedQuotes.length > 0 && !showMobileFilters && (
            <StickyButtonContainer>
              <Button
                onClick={onConfirmClick}
                size="large"
                icon="arrow-right"
                arrangement="leading-label"
                disabled={selectedQuotes.length === 0}
              >
                View and confirm quotes
              </Button>
            </StickyButtonContainer>
          )}
        </div>
      </div>
    </BaseLayout>
  );
}
